<script>
    export let tip;
    import { fade} from 'svelte/transition';

    let loaded = false;

    setTimeout(() => {
        loaded = true;
    }, 200)

</script>

{#if loaded}
<div class="fancybox-outer pancakeism-modal">
    <div class="fancybox-inner pancakeism-modal" transition:fade>
        <!-- Detail view of Pancake-ism and Tips -->
        <section class="bg-hub-item tip"
                 style="background-image: url({tip.image}); ">
            <div class="inner" style="text-shadow: 0 0 10px #000000;">
                <h1>{@html tip.content}</h1>
            </div>
        </section>
    </div>
</div>
{/if}

<style>



    .fancybox-inner.pancakeism-modal {
        width: 100%;
        min-height: 480px;
        overflow: auto;
    }
    @media screen and (min-width: 657px) {
        .fancybox-inner.pancakeism-modal {
            width: 657px;
            min-height: 480px;
            overflow: auto;
        }

    }

    h1 {
        max-width: 60%;
    }

    h1:after {
        content: '';
        display: block;
        height: 84px;
        background-image: url(/wp-content/themes/hungryjack/images/home/pancakeisms_logo.png);
        background-size: 80%;
        background-repeat: no-repeat;
        background-position: 50% 100%;
        margin: 0 auto;
        max-width: 280px;
    }

</style>